const deepRemove = (array, id) => array.reduce((acc, item) => {
  if (item.id === id) {
    return acc;
  }

  if (item.navigationItems) {
    return [
      ...acc,
      { ...item, navigationItems: deepRemove(item.navigationItems, id) },
    ];
  }

  return [...acc, item];
}, []);

export default deepRemove;
